import type { SystemVersionDTO } from "@repo/codegen/teashop-base-api"

function getModuleVersionByType(systemVersion: Pick<SystemVersionDTO, "versionModuleRels"> | null, moduleType: number) {
  return systemVersion?.versionModuleRels?.find(rel => rel.moduleType === moduleType)?.moduleVersion
}

export function resolveDisplayedSystemVersion(
  systemVersion: Pick<SystemVersionDTO, "systemVersion"> | null,
) {
  const aggregateVersion = systemVersion?.systemVersion?.systemVersion?.trim()
  return aggregateVersion || undefined
}

export function resolveIsGrayVersion(
  systemVersion: Pick<SystemVersionDTO, "systemVersion"> | null,
) {
  return systemVersion?.systemVersion?.isGray === 1
}

export function resolveApiVersionByModulePrefix(
  modulePrefix: string,
  systemVersion: Pick<SystemVersionDTO, "versionModuleRels"> | null,
) {
  switch (modulePrefix) {
    case 'teashop_supplier':
      return getModuleVersionByType(systemVersion, 3)
    case 'teashop_merchant':
      return getModuleVersionByType(systemVersion, 2)
    case 'teashop_base':
      return getModuleVersionByType(systemVersion, 1)
    default:
      return undefined
  }
}
